import {
    Box,
    Container,
    Grid,
    GridItem,
    Image,
    RadioGroup,
    Spinner,
    Stack,
    Text,
    useBreakpointValue,
} from "@chakra-ui/react";
import { useEffect, useState } from "react";

import CustomCircularProgress from "@/components/general/CustomCircularProgress";
import { useGetDigitalCardByIdQuery } from "@/hooks/microservicesApi";

const Asesor = ({ id, ...props }) => {
    const [isActive, setIsActive] = useState(false);
    const [employee, setEmployee] = useState(null);
    const [loaded, setLoaded] = useState(false);

    const { data, error } = useGetDigitalCardByIdQuery(id);

    const isGreaterThanMd = useBreakpointValue({ base: false, md: true });

    useEffect(() => {
        if (id && data) {
            if (data) {
                setEmployee(data.data);
                setIsActive(data.data?.is_active);
                setLoaded(true);
            } else {
                setEmployee("Not found");
                setLoaded(true);
            }
        }
    }, [data]);

    return (
        <>
            <Container maxW={{ base: "md", md: "4xl" }} padding={{ base: 10, md: 18 }} {...props}>
                {employee && loaded ? (
                    <Grid
                        templateColumns={isGreaterThanMd ? "repeat(3, 1fr)" : "repeat(2, 1fr)"}
                        gap={6}
                    >
                        <GridItem colSpan={1}>
                            <Box
                                position="relative"
                                boxSize="2xs"
                                borderRadius="full"
                                alignContent="center"
                            >
                                <CustomCircularProgress
                                    value={50}
                                    ringColor="transparent"
                                    color="#FFCD00"
                                    displayText={" "}
                                    size="2xs"
                                />
                                {/* La imagen de perfil */}
                                <Image
                                    src={
                                        isActive
                                            ? `https://${employee.profile_image}`
                                            : "https://media.grupoguia.mx/assets/home-page/Asesores/contacto.webp"
                                    }
                                    alt="Perfil"
                                    width="92%"
                                    height="92%"
                                    borderRadius={isActive ? "full" : "0%"}
                                    opacity={isActive ? 1 : 0.3}
                                    objectFit="cover"
                                    objectPosition="center"
                                    position="absolute"
                                    top="50%"
                                    left="50%"
                                    transform="translate(-50%, -50%)"
                                    style={{
                                        imageRendering: "auto",
                                        imageResolution: "300dpi",
                                    }}
                                />
                            </Box>
                        </GridItem>
                        <GridItem colSpan={2}>
                            <Grid
                                templateColumns={
                                    isGreaterThanMd ? "repeat(1, 1fr)" : "repeat(1, 1fr)"
                                }
                                gap={10}
                            >
                                <GridItem colSpan={1}>
                                    <Text fontSize="sm" fontWeight="400" display="inline-flex">
                                        Status:
                                        <RadioGroup.Root>
                                            <RadioGroup.Item
                                                size="sm"
                                                name="1"
                                                color={
                                                    isActive
                                                        ? "#38a169 !important"
                                                        : "#F0F0F0 !important"
                                                }
                                                colorPalette={isActive ? "green" : "gray"}
                                                ml={6}
                                                checked={isActive}
                                                disabled={!isActive}
                                            >
                                                <RadioGroup.ItemHiddenInput />
                                                <RadioGroup.ItemIndicator />
                                                <RadioGroup.ItemText color="black">
                                                    Activo
                                                </RadioGroup.ItemText>
                                            </RadioGroup.Item>
                                            <RadioGroup.Item
                                                size="sm"
                                                name="1"
                                                color={
                                                    isActive
                                                        ? "gray.400 !important"
                                                        : "#e53e3e !important"
                                                }
                                                colorPalette={isActive ? "gray" : "red"}
                                                ml={6}
                                                disabled={isActive}
                                                checked={!isActive}
                                            >
                                                <RadioGroup.ItemHiddenInput />
                                                <RadioGroup.ItemIndicator />
                                                <RadioGroup.ItemText
                                                    color={isActive ? "gray" : "black"}
                                                >
                                                    Inactivo
                                                </RadioGroup.ItemText>
                                            </RadioGroup.Item>
                                        </RadioGroup.Root>
                                        <RadioGroup.Root></RadioGroup.Root>
                                    </Text>
                                </GridItem>
                                <GridItem colSpan={1}>
                                    <Text fontSize="2xl" fontWeight="700">
                                        {isActive
                                            ? employee.name +
                                              " " +
                                              employee.last_name +
                                              " " +
                                              employee.mothers_last_name
                                            : "Asesor no disponible"}
                                    </Text>
                                    <Text
                                        fontSize="lg"
                                        fontWeight="400"
                                        w={!isActive && isGreaterThanMd ? "55%" : "90%"}
                                    >
                                        {isActive
                                            ? employee.job_position
                                            : "El asesor se encuentra inactivo y ya no colabora en Grupo Guia"}
                                    </Text>
                                </GridItem>
                                {isActive ? (
                                    <GridItem colSpan={1}>
                                        <Text fontSize="sm" fontWeight="400">
                                            {employee.email}
                                        </Text>
                                        <Text fontSize="sm" fontWeight="400">
                                            T.{" "}
                                            {employee.cellphone
                                                ? employee.cellphone
                                                : employee.phone}
                                        </Text>
                                    </GridItem>
                                ) : null}
                            </Grid>
                        </GridItem>
                    </Grid>
                ) : employee !== "Not found" && employee === null && loaded === false && !error ? (
                    <Stack maxW="7xl" margin="auto" textAlign="center" alignItems="center">
                        <Spinner
                            borderWidth="4px"
                            animationDuration="0.65s"
                            emptyColor="gray.200"
                            color="yellow.300"
                            size="lg"
                        />
                        <Text>Estamos cargando la información, por favor, espera ...</Text>
                    </Stack>
                ) : (
                    <>El usuario no existe</>
                )}
            </Container>
        </>
    );
};

export default Asesor;
